import type { Fields } from '../../types';
import { FieldTypes } from '../../types/fieldTypes';
import { lifeStyle, testType } from './options';

// https://www.gdsuite.it/laravel/v1/visita/data?pk_id_pt=37392&pk_id_vt=26030&group=700
export const step0: Fields = [
  {
    name: 'Altezza',
    type: FieldTypes.number,
    unit: 'cm',
    code: 701,
    group: 700,
    min: 0,
    errors: ['min', 'required', 'number'],
  },
  {
    name: 'Peso',
    type: FieldTypes.number,
    unit: 'kg',
    min: 0,
    code: 702,
    group: 700,
    errors: ['min', 'required', 'number'],
  },
  {
    name: 'Attività fisica',
    type: FieldTypes.radio,
    options: lifeStyle,
    code: 703,
    group: 700,
    errors: ['required'],
  },
  {
    name: 'Che tipo di test vuoi effettuare?',
    type: FieldTypes.checkbox,
    options: testType,
    code: 99991,
    group: 9991,
    errors: ['required'],
    note: 'Puoi consultare la lista dei nostri test da <a href="https://inostritest.ngbgenetics.com/" target="new">qui (https://inostritest.ngbgenetics.com/)</a>',
  },
];
